import { ReactNode } from 'react';
import { useFlexCol } from '../hooks/useFlexCol';

type FlexColChildProps = {
	children: ReactNode;
};

const FlexColChild = ({ children }: FlexColChildProps) => {
	const { blockClass, preventVerticalStretch, verticalAlign, rowGap } = useFlexCol();

	const renderClass = () => {
		return blockClass && `vtex-flex-layout-0-x-flexColChild--${blockClass} flexColChild--${blockClass}`;
	};

	const renderStyles = () => {
		return preventVerticalStretch || verticalAlign
			? {
					height: 'auto',
				}
			: {
					height: '100%',
				};
	};

	return (
		<div
			className={`vtex-flex-layout-0-x-flexColChild flexColChild ${renderClass()} pb${rowGap || 0}`}
			style={renderStyles()}
		>
			{children}
		</div>
	);
};

export default FlexColChild;
